import { z } from "zod";
import { createMemoryStore, createSessionStore } from "../../lib/store";

/**
 * What this session of the app did with the wizard (docs/juiscigpt-wizard.md).
 * The server holds the tour state; these are the per-session rules on top:
 * - `invitation`: at most one invitation per session (INV-01). `shown` keeps
 *   the card while the server records it; `answered` hides it at once.
 *   `restarted` is the Settings entry (REQ-21): the invitation card shows
 *   again, whatever the gate.
 * - `composerTouched`: no invitation once the reader focused the composer or
 *   sent a question in the session (INV-02).
 * - `tour`: a running tour shows its notes only in the session that started
 *   or resumed it. A new session, or "Quitter la visite", shows the pause
 *   banner instead (REQ-17, Figma C1).
 */
const wizardSessionSchema = z.object({
  invitation: z.enum(["unseen", "shown", "restarted", "answered"]),
  composerTouched: z.boolean(),
  tour: z.enum(["paused", "active"]),
});
export const useWizardSession = createSessionStore<
  z.infer<typeof wizardSessionSchema>
>(
  "juiscigpt-wizard-session",
  { invitation: "unseen", composerTouched: false, tour: "paused" },
  wizardSessionSchema
);

/**
 * The note of the wizard folded into a bar above the composer: its close
 * control, a tap outside it, or a scroll of the answer (REQ-14, REQ-15). A tap
 * on the bar opens the note again.
 */
export const useWizardNoteCollapsed = createMemoryStore(false);
